/// <reference types="vite/client" />

/**
 * Build-time public env values, injected by vite.config.ts `define`.
 *
 * Only PUBLIC_* keys are exposed to the client bundle (read from `.dev.vars`
 * at build time). Server-only secrets (RESEND_API_KEY, TURNSTILE_SECRET_KEY,
 * GOOGLE_CLIENT_SECRET) NEVER reach this file — they live only in the
 * Pages Function runtime env.
 */

interface ImportMetaEnv {
  readonly PUBLIC_TURNSTILE_SITE_KEY?: string;
}

interface ImportMeta {
  readonly env: ImportMetaEnv;
}

export const TURNSTILE_SITE_KEY = (import.meta as ImportMeta).env.PUBLIC_TURNSTILE_SITE_KEY;

/**
 * Cloudflare's well-known test site keys, used when no real key is set
 * (typically only in local dev where .dev.vars may not be readable).
 * https://developers.cloudflare.com/turnstile/troubleshooting/testing/
 */
export const TURNSTILE_TEST_KEYS = {
  alwaysPass: '1x00000000000000000000AA',
  alwaysBlock: '2x00000000000000000000AB',
  forceChallenge: '3x00000000000000000000FF',
} as const;

/** The site key to actually render in widgets. Falls back to the always-pass test key. */
export const TURNSTILE_KEY = TURNSTILE_SITE_KEY || TURNSTILE_TEST_KEYS.alwaysPass;
